"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emojis = void 0;
exports.emojis = [
    '⌚',
    '⏩',
    '⏪',
    '⏫',
    '⏰',
    '⏳',
    '◽',
    '☔',
    '♈',
    '♉',
    '♊',
    '♋',
    '♌',
    '♍',
    '♎',
    '♏',
    '♐',
    '♑',
    '♒',
    '♿',
    '⚓',
    '⚡',
    '⚪',
    '⚽',
    '⛄',
    '⛎',
    '⛔',
    '⛪',
    '⛲',
    '⛵',
    '⛺',
    '⛽',
    '✅',
    '✊',
    '✨',
    '❌',
    '❎',
    '❓',
    '❔',
    '❗',
    '➕',
    '➖',
    '➰',
    '➿',
    '⬛',
    '⭐',
    '⭕',
    '🀄',
    '🃏',
    '🆎',
    '🆑',
    '🆒',
    '🆓',
    '🆔',
    '🆕',
    '🆖',
    '🆗',
    '🆘',
    '🆙',
    '🈁',
    '🈚',
    '🈯',
    '🈲',
    '🈳',
    '🈴',
    '🈵',
    '🈸',
    '🈹',
    '🉐',
    '🌀',
    '🌁',
    '🌂',
    '🌃',
    '🌄',
    '🌅',
    '🌆',
    '🌇',
    '🌈',
    '🌉',
    '🌊',
    '🌋',
    '🌍',
    '🌏',
    '🌐',
    '🌑',
    '🌒',
    '🌓',
    '🌔',
    '🌖',
    '🌗',
    '🌙',
    '🌚',
    '🌛',
    '🌜',
    '🌝',
    '🌟',
    '🌭',
    '🌮',
    '🌰',
    '🌲',
    '🌴',
    '🌷',
    '🌸',
    '🌹',
    '🌺',
    '🌻',
    '🌼',
    '🌽',
    '🌾',
    '🌿',
    '🍀',
    '🍁',
    '🍂',
    '🍃',
    '🍄',
    '🍅',
    '🍆',
    '🍇',
    '🍈',
    '🍉',
    '🍋',
    '🍌',
    '🍍',
    '🍎',
    '🍐',
    '🍑',
    '🍒',
    '🍓',
    '🍔',
    '🍕',
    '🍖',
    '🍗',
    '🍘',
    '🍙',
    '🍚',
    '🍛',
    '🍜',
    '🍝',
    '🍞',
    '🍟',
    '🍠',
    '🍡',
    '🍢',
    '🍣',
    '🍤',
    '🍥',
    '🍦',
    '🍧',
    '🍨',
    '🍩',
    '🍪',
    '🍫',
    '🍬',
    '🍭',
    '🍮',
    '🍯',
    '🍰',
    '🍱',
    '🍲',
    '🍳',
    '🍴',
    '🍵',
    '🍶',
    '🍷',
    '🍸',
    '🍹',
    '🍺',
    '🍼',
    '🍾',
    '🎀',
    '🎁',
    '🎂',
    '🎃',
    '🎄',
    '🎅',
    '🎆',
    '🎇',
    '🎈',
    '🎉',
    '🎊',
    '🎋',
    '🎌',
    '🎍',
    '🎎',
    '🎏',
    '🎐',
    '🎑',
    '🎒',
    '🎠',
    '🎡',
    '🎢',
    '🎣',
    '🎤',
    '🎥',
    '🎦',
    '🎧',
    '🎨',
    '🎩',
    '🎪',
    '🎫',
    '🎬',
    '🎭',
    '🎮',
    '🎯',
    '🎰',
    '🎱',
    '🎲',
    '🎳',
    '🎴',
    '🎵',
    '🎶',
    '🎷',
    '🎸',
    '🎹',
    '🎺',
    '🎻',
    '🎼',
    '🎽',
    '🎾',
    '🎿',
    '🏀',
    '🏁',
    '🏂',
    '🏃',
    '🏅',
    '🏆',
    '🏇',
    '🏈',
    '🏉',
    '🏊',
    '🏏',
    '🏐',
    '🏑',
    '🏒',
    '🏠',
    '🏡',
    '🏢',
    '🏤',
    '🏥',
    '🏦',
    '🏧',
    '🏨',
    '🏩',
    '🏪',
    '🏫',
    '🏬',
    '🏭',
    '🏮',
    '🏯',
    '🏴',
    '🏸',
    '🏹',
    '🏺',
    '🐀',
    '🐁',
    '🐂',
    '🐃',
    '🐄',
    '🐅',
    '🐆',
    '🐈',
    '🐉',
    '🐊',
    '🐌',
    '🐍',
    '🐏',
    '🐑',
    '🐓',
    '🐔',
    '🐕',
    '🐖',
    '🐗',
    '🐘',
    '🐙',
    '🐚',
    '🐛',
    '🐜',
    '🐝',
    '🐞',
    '🐟',
    '🐠',
    '🐡',
    '🐢',
    '🐣',
    '🐤',
    '🐥',
    '🐦',
    '🐧',
    '🐨',
    '🐪',
    '🐫',
    '🐬',
    '🐭',
    '🐮',
    '🐯',
    '🐰',
    '🐱',
    '🐲',
    '🐳',
    '🐴',
    '🐵',
    '🐶',
    '🐷',
    '🐸',
    '🐹',
    '🐺',
    '🐻',
    '🐼',
    '🐽',
    '👀',
    '👂',
    '👃',
    '👄',
    '👅',
    '👆',
    '👇',
    '👈',
    '👉',
    '👊',
    '👋',
    '👌',
    '👍',
    '👎',
    '👏',
    '👐',
    '👑',
    '👒',
    '👓',
    '👔',
    '👕',
    '👖',
    '👗',
    '👘',
    '👙',
    '👚',
    '👛',
    '👜',
    '👝',
    '👞',
    '👟',
    '👠',
    '👡',
    '👢',
    '👣',
    '👥',
    '👦',
    '👧',
    '👨',
    '👩',
    '👪',
    '👬',
    '👮',
    '👯',
    '👰',
    '👱',
    '👲',
    '👳',
    '👴',
    '👵',
    '👶',
    '👷',
    '👸',
    '👹',
    '👺',
    '👻',
    '👼',
    '👽',
    '👾',
    '👿',
    '💀',
    '💁',
    '💂',
    '💃',
    '💄',
    '💅',
    '💆',
    '💇',
    '💈',
    '💉',
    '💊',
    '💋',
    '💌',
    '💍',
    '💎',
    '💏',
    '💐',
    '💑',
    '💒',
    '💓',
    '💔',
    '💕',
    '💖',
    '💗',
    '💘',
    '💙',
    '💚',
    '💛',
    '💜',
    '💝',
    '💞',
    '💟',
    '💠',
    '💡',
    '💢',
    '💣',
    '💤',
    '💥',
    '💦',
    '💧',
    '💨',
    '💩',
    '💪',
    '💫',
    '💭',
    '💮',
    '💯',
    '💰',
    '💱',
    '💲',
    '💳',
    '💴',
    '💶',
    '💸',
    '💹',
    '💺',
    '💻',
    '💼',
    '💽',
    '💾',
    '💿',
    '📀',
    '📁',
    '📂',
    '📃',
    '📄',
    '📅',
    '📆',
    '📇',
    '📈',
    '📉',
    '📊',
    '📋',
    '📌',
    '📍',
    '📎',
    '📏',
    '📐',
    '📑',
    '📒',
    '📓',
    '📔',
    '📕',
    '📖',
    '📗',
    '📘',
    '📙',
    '📚',
    '📛',
    '📜',
    '📝',
    '📞',
    '📟',
    '📠',
    '📡',
    '📢',
    '📣',
    '📤',
    '📥',
    '📦',
    '📧',
    '📨',
    '📩',
    '📪',
    '📬',
    '📮',
    '📯',
    '📰',
    '📱',
    '📲',
    '📳',
    '📵',
    '📶',
    '📸',
    '📹',
    '📺',
    '📻',
    '📿',
    '🔀',
    '🔁',
    '🔃',
    '🔄',
    '🔅',
    '🔆',
    '🔈',
    '🔉',
    '🔊',
    '🔋',
    '🔌',
    '🔍',
    '🔎',
    '🔏',
    '🔐',
    '🔑',
    '🔒',
    '🔓',
    '🔕',
    '🔖',
    '🔗',
    '🔘',
    '🔙',
    '🔚',
    '🔛',
    '🔜',
    '🔝',
    '🔞',
    '🔟',
    '🔠',
    '🔡',
    '🔢',
    '🔣',
    '🔤',
    '🔥',
    '🔦',
    '🔧',
    '🔨',
    '🔩',
    '🔪',
    '🔬',
    '🔮',
    '🔯',
    '🔰',
    '🔱',
    '🔲',
    '🔳',
    '🔴',
    '🔵',
    '🔶',
    '🔷',
    '🔸',
    '🔹',
    '🔺',
    '🔻',
    '🔼',
    '🕋',
    '🕌',
    '🕍',
    '🕐',
    '🕑',
    '🕒',
    '🕓',
    '🕔',
    '🕕',
    '🕖',
    '🕗',
    '🕘',
    '🕙',
    '🕚',
    '🕜',
    '🕝',
    '🕞',
    '🕟',
    '🕠',
    '🕡',
    '🕢',
    '🕣',
    '🕤',
    '🕥',
    '🕦',
    '🕺',
    '🖕',
    '🖤',
    '🗻',
    '🗼',
    '🗽',
    '🗾',
    '😀',
    '😁',
    '😂',
    '😃',
    '😄',
    '😅',
    '😇',
    '😉',
    '😊',
    '😋',
    '😌',
    '😎',
    '😏',
    '😐',
    '😑',
    '😒',
    '😓',
    '😕',
    '😖',
    '😗',
    '😘',
    '😙',
    '😚',
    '😛',
    '😜',
    '😝',
    '😟',
    '😠',
    '😡',
    '😢',
    '😣',
    '😤',
    '😦',
    '😨',
    '😩',
    '😪',
    '😬',
    '😭',
    '😮',
    '😰',
    '😱',
    '😲',
    '😴',
    '😵',
    '😶',
    '😷',
    '😸',
    '😹',
    '😺',
    '😻',
    '😼',
    '😽',
    '😾',
    '😿',
    '🙁',
    '🙂',
    '🙃',
    '🙅',
    '🙆',
    '🙇',
    '🙈',
    '🙉',
    '🙊',
    '🙋',
    '🙌',
    '🙍',
    '🙎',
    '🚀',
    '🚁',
    '🚃',
    '🚄',
    '🚆',
    '🚇',
    '🚈',
    '🚉',
    '🚊',
    '🚌',
    '🚍',
    '🚎',
    '🚏',
    '🚐',
    '🚑',
    '🚒',
    '🚔',
    '🚕',
    '🚖',
    '🚗',
    '🚘',
    '🚙',
    '🚛',
    '🚜',
    '🚝',
    '🚞',
    '🚟',
    '🚠',
    '🚢',
    '🚣',
    '🚤',
    '🚦',
    '🚧',
    '🚨',
    '🚩',
    '🚪',
    '🚫',
    '🚬',
    '🚮',
    '🚯',
    '🚰',
    '🚲',
    '🚳',
    '🚴',
    '🚶',
    '🚷',
    '🚹',
    '🚺',
    '🚻',
    '🚼',
    '🚽',
    '🚿',
    '🛀',
    '🛁',
    '🛂',
    '🛃',
    '🛄',
    '🛌',
    '🛐',
    '🛑',
    '🛕',
    '🛖',
    '🛫',
    '🛴',
    '🛵',
    '🛷',
    '🛹',
    '🛺',
    '🛻',
    '🟠',
    '🟡',
    '🟢',
    '🟣',
    '🟤',
    '🟥',
    '🟦',
    '🟧',
    '🟨',
    '🟩',
    '🟪',
    '🤌',
    '🤍',
    '🤎',
    '🤐',
    '🤑',
    '🤒',
    '🤓',
    '🤔',
    '🤕',
    '🤖',
    '🤗',
    '🤙',
    '🤚',
    '🤛',
    '🤜',
    '🤝',
    '🤟',
    '🤠',
    '🤡',
    '🤢',
    '🤣',
    '🤤',
    '🤥',
    '🤦',
    '🤨',
    '🤩',
    '🤪',
    '🤫',
    '🤬',
    '🤭',
    '🤮',
    '🤰',
    '🤱',
    '🤳',
    '🤴',
    '🤵',
    '🤶',
    '🤷',
    '🤸',
    '🤹',
    '🤼',
    '🤽',
    '🤿',
    '🥀',
    '🥁',
    '🥂',
    '🥃',
    '🥄',
    '🥇',
    '🥈',
    '🥉',
    '🥊',
    '🥌',
    '🥍',
    '🥎',
    '🥐',
    '🥑',
    '🥒',
    '🥓',
    '🥔',
    '🥕',
    '🥖',
    '🥗',
    '🥘',
    '🥙',
    '🥚',
    '🥛',
    '🥜',
    '🥝',
    '🥟',
    '🥠',
    '🥡',
    '🥢',
    '🥣',
    '🥤',
    '🥥',
    '🥦',
    '🥧',
    '🥨',
    '🥩',
    '🥪',
    '🦀',
    '🦁',
    '🦂',
    '🦃',
    '🦅',
    '🦆',
    '🦇',
    '🦈',
    '🦉',
    '🦊',
    '🦋',
    '🦌',
    '🦍',
    '🦎',
    '🦏',
    '🦐',
    '🦒',
    '🦓',
    '🦔',
    '🦕',
    '🦖',
    '🦘',
    '🦙',
    '🦚',
    '🦛',
    '🦜',
    '🦝',
    '🦞',
    '🦟',
    '🦠',
    '🦡',
    '🦣',
    '🦥',
    '🦦',
    '🦧',
    '🦨',
    '🦩',
    '🦫',
    '🦬',
    '🦮',
    '🦰',
    '🦱',
    '🦲',
    '🦳',
    '🦴',
    '🦵',
    '🦶',
    '🦷',
    '🦸',
    '🦺',
    '🦻',
    '🦼',
    '🦽',
    '🦾',
    '🧀',
    '🧁',
    '🧃',
    '🧄',
    '🧅',
    '🧆',
    '🧇',
    '🧈',
    '🧉',
    '🧋',
    '🧍',
    '🧎',
    '🧐',
    '🧑',
    '🧒',
    '🧓',
    '🧔',
    '🧕',
    '🧖',
    '🧗',
    '🧘',
    '🧙',
    '🧚',
    '🧛',
    '🧜',
    '🧝',
    '🧞',
    '🧟',
    '🧠',
    '🧡',
    '🧢',
    '🧣',
    '🧤',
    '🧥',
    '🧧',
    '🧨',
    '🧩',
    '🧪',
    '🧫',
    '🧬',
    '🧭',
    '🧮',
    '🧯',
    '🧰',
    '🧱',
    '🧲',
    '🧳',
    '🧴',
    '🧵',
    '🧶',
    '🧷',
    '🧸',
    '🧹',
    '🧺',
    '🧻',
    '🧼',
    '🧽',
    '🧾',
    '🩰',
    '🩱',
    '🩲',
    '🩴',
    '🩸',
    '🩹',
    '🪀',
    '🪁',
    '🪃',
    '🪄',
    '🪅',
    '🪐',
    '🪑',
    '🪒',
    '🪓',
    '🪔',
    '🪖',
    '🪗',
    '🪘',
    '🪙',
    '🪚',
    '🪛',
    '🪜',
    '🪝',
    '🪞',
    '🪟',
    '🪠',
    '🪡',
    '🪢',
    '🪣',
    '🪤',
    '🪥',
    '🪦',
    '🪧',
    '🪰',
    '🪱',
    '🪲',
    '🪳',
    '🪴',
    '🪵',
    '🫀',
    '🫁',
    '🫐',
    '🫑',
    '🫒',
    '🫓',
    '🫔',
    '🫕',
    '©️',
    '®️',
    '‼️',
    '⁉️',
    '™️',
    'ℹ️',
    '↔️',
    '↕️',
    '↖️',
    '↗️',
    '↘️',
    '↙️',
    '↩️',
    '↪️',
    '⌨️',
    '⏏️',
    '⏭️',
    '⏮️',
    '⏯️',
    '⏱️',
    '⏲️',
    '⏸️',
    '⏹️',
    '⏺️',
    'Ⓜ️',
    '▪️',
    '▫️',
    '▶️',
    '◀️',
    '◻️',
    '◼️',
    '☀️',
    '☁️',
    '☂️',
    '☃️',
    '☄️',
    '☎️',
    '☑️',
    '☘️',
    '☝️',
    '☠️',
    '☢️',
    '☣️',
    '☦️',
    '☪️',
    '☮️',
    '☯️',
    '☸️',
    '☹️',
    '☺️',
    '♀️',
    '♂️',
    '♟️',
    '♠️',
    '♣️',
    '♥️',
    '♦️',
    '♨️',
    '♻️',
    '♾️',
    '⚒️',
    '⚔️',
    '⚕️',
    '⚖️',
    '⚗️',
    '⚙️',
    '⚛️',
    '⚜️',
    '⚠️',
    '⚧️',
    '⚰️',
    '⚱️',
    '⛈️',
    '⛏️',
    '⛑️',
    '⛓️',
    '⛩️',
    '⛰️',
    '⛱️',
    '⛴️',
    '⛷️',
    '⛸️',
    '⛹️',
    '✂️',
    '✈️',
    '✉️',
    '✌️',
    '✍️',
    '✏️',
    '✒️',
    '✔️',
    '✖️',
    '✝️',
    '✡️',
    '✳️',
    '✴️',
    '❄️',
    '❇️',
    '❣️',
    '❤️',
    '➡️',
    '⤴️',
    '⤵️',
    '⬅️',
    '⬆️',
    '⬇️',
    '〰️',
    '〽️',
    '㊗️',
    '㊙️',
    '🅰️',
    '🅱️',
    '🅾️',
    '🅿️',
    '🈂️',
    '🈷️',
    '🌡️',
    '🌤️',
    '🌥️',
    '🌦️',
    '🌧️',
    '🌨️',
    '🌩️',
    '🌪️',
    '🌫️',
    '🌬️',
    '🌶️',
    '🍽️',
    '🎖️',
    '🎗️',
    '🎙️',
    '🎚️',
    '🎛️',
    '🎞️',
    '🎟️',
    '🏋️',
    '🏌️',
    '🏍️',
    '🏎️',
    '🏔️',
    '🏕️',
    '🏖️',
    '🏗️',
    '🏘️',
    '🏙️',
    '🏚️',
    '🏛️',
    '🏜️',
    '🏝️',
    '🏞️',
    '🏟️',
    '🏳️',
    '🏵️',
    '🏷️',
    '🐿️',
    '👁️',
    '📽️',
    '🕉️',
    '🕊️',
    '🕯️',
    '🕰️',
    '🕳️',
    '🕴️',
    '🕵️',
    '🕶️',
    '🕷️',
    '🕸️',
    '🕹️',
    '🖇️',
    '🖊️',
    '🖋️',
    '🖌️',
    '🖍️',
    '🖐️',
    '🖥️',
    '🖨️',
    '🖱️',
    '🖲️',
    '🖼️',
    '🗂️',
    '🗃️',
    '🗄️',
    '🗑️',
    '🗒️',
    '🗓️',
    '🗜️',
    '🗝️',
    '🗞️',
    '🗡️',
    '🗣️',
    '🗨️',
    '🗯️',
    '🗳️',
    '🗺️',
    '🛋️',
    '🛍️',
    '🛎️',
    '🛏️',
    '🛠️',
    '🛡️',
    '🛢️',
    '🛣️',
    '🛤️',
    '🛥️',
    '🛩️',
    '🛰️',
    '🛳️',
    '#️⃣',
    '*️⃣',
    '0️⃣',
    '1️⃣',
    '2️⃣',
    '3️⃣',
    '4️⃣',
    '5️⃣',
    '6️⃣',
    '7️⃣',
    '8️⃣',
    '9️⃣',
    '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
    '☝',
    '☝',
    '☝',
    '☝',
    '☝',
    '⛹',
    '⛹',
    '⛹',
    '⛹',
    '⛹',
    '✊',
    '✊',
    '✊',
    '✊',
    '✊',
    '✋   ',
    '✋  ',
    '✋  ',
    '✋   ',
    '✋   ',
    '✌   ',
    '✌  ',
    '✌  ',
    '✌   ',
    '✌   ',
    '✍   ',
    '✍  ',
    '✍  ',
    '✍   ',
    '✍   ',
    '🎅   ',
    '🎅  ',
    '🎅  ',
    '🎅   ',
    '🎅   ',
    '🏂   ',
    '🏂  ',
    '🏂  ',
    '🏂   ',
    '🏂   ',
    '🏃   ',
    '🏃  ',
    '🏃  ',
    '🏃   ',
    '🏃   ',
    '🏄   ',
    '🏄  ',
    '🏄  ',
    '🏄   ',
    '🏄   ',
    '🏇   ',
    '🏇  ',
    '🏇  ',
    '🏇   ',
    '🏇   ',
    '🏊   ',
    '🏊  ',
    '🏊  ',
    '🏊   ',
    '🏊   ',
    '🏋   ',
    '🏋  ',
    '🏋  ',
    '🏋   ',
    '🏋   ',
    '🏌   ',
    '🏌  ',
    '🏌  ',
    '🏌   ',
    '🏌   ',
    '👂   ',
    '👂  ',
    '👂  ',
    '👂   ',
    '👂   ',
    '👃   ',
    '👃  ',
    '👃  ',
    '👃   ',
    '👃   ',
    '👆   ',
    '👆  ',
    '👆  ',
    '👆   ',
    '👆   ',
    '👇   ',
    '👇  ',
    '👇  ',
    '👇   ',
    '👇   ',
    '👈   ',
    '👈  ',
    '👈  ',
    '👈   ',
    '👈   ',
    '👉   ',
    '👉  ',
    '👉  ',
    '👉   ',
    '👉   ',
    '👊   ',
    '👊  ',
    '👊  ',
    '👊   ',
    '👊   ',
    '👋   ',
    '👋  ',
    '👋  ',
    '👋   ',
    '👋   ',
    '👌   ',
    '👌  ',
    '👌  ',
    '👌   ',
    '👌   ',
    '👍   ',
    '👍  ',
    '👍  ',
    '👍   ',
    '👍   ',
    '👎   ',
    '👎  ',
    '👎  ',
    '👎   ',
    '👎   ',
    '👏   ',
    '👏  ',
    '👏  ',
    '👏   ',
    '👏   ',
    '👐   ',
    '👐  ',
    '👐  ',
    '👐   ',
    '👐   ',
    '👦   ',
    '👦  ',
    '👦  ',
    '👦   ',
    '👦   ',
    '👧   ',
    '👧  ',
    '👧  ',
    '👧   ',
    '👧   ',
    '👨   ',
    '👨  ',
    '👨  ',
    '👨   ',
    '👨   ',
    '👩   ',
    '👩  ',
    '👩  ',
    '👩   ',
    '👩   ',
    '👫   ',
    '👫  ',
    '👫  ',
    '👫   ',
    '👫   ',
    '👬   ',
    '👬  ',
    '👬  ',
    '👬   ',
    '👬   ',
    '👭   ',
    '👭  ',
    '👭  ',
    '👭   ',
    '👭   ',
    '👮   ',
    '👮  ',
    '👮  ',
    '👮   ',
    '👮   ',
    '👰   ',
    '👰  ',
    '👰  ',
    '👰   ',
    '👰   ',
    '👱   ',
    '👱  ',
    '👱  ',
    '👱   ',
    '👱   ',
    '👲   ',
    '👲  ',
    '👲  ',
    '👲   ',
    '👲   ',
    '👳   ',
    '👳  ',
    '👳  ',
    '👳   ',
    '👳   ',
    '👴   ',
    '👴  ',
    '👴  ',
    '👴   ',
    '👴   ',
    '👵   ',
    '👵  ',
    '👵  ',
    '👵   ',
    '👵   ',
    '👶   ',
    '👶  ',
    '👶  ',
    '👶   ',
    '👶   ',
    '👷   ',
    '👷  ',
    '👷  ',
    '👷   ',
    '👷   ',
    '👸   ',
    '👸  ',
    '👸  ',
    '👸   ',
    '👸   ',
    '👼   ',
    '👼  ',
    '👼  ',
    '👼   ',
    '👼   ',
    '💁   ',
    '💁  ',
    '💁  ',
    '💁   ',
    '💁   ',
    '💂   ',
    '💂  ',
    '💂  ',
    '💂   ',
    '💂   ',
    '💃   ',
    '💃  ',
    '💃  ',
    '💃   ',
    '💃   ',
    '💅   ',
    '💅  ',
    '💅  ',
    '💅   ',
    '💅   ',
    '💆   ',
    '💆  ',
    '💆  ',
    '💆   ',
    '💆   ',
    '💇   ',
    '💇  ',
    '💇  ',
    '💇   ',
    '💇   ',
    '💏   ',
    '💏  ',
    '💏  ',
    '💏   ',
    '💏   ',
    '💑   ',
    '💑  ',
    '💑  ',
    '💑   ',
    '💑   ',
    '💪   ',
    '💪  ',
    '💪  ',
    '💪   ',
    '💪   ',
    '🕴   ',
    '🕴  ',
    '🕴  ',
    '🕴   ',
    '🕴   ',
    '🕵   ',
    '🕵  ',
    '🕵  ',
    '🕵   ',
    '🕵   ',
    '🕺   ',
    '🕺  ',
    '🕺  ',
    '🕺   ',
    '🕺   ',
    '🖐   ',
    '🖐  ',
    '🖐  ',
    '🖐   ',
    '🖐   ',
    '🖕   ',
    '🖕  ',
    '🖕  ',
    '🖕   ',
    '🖕   ',
    '🖖   ',
    '🖖  ',
    '🖖  ',
    '🖖   ',
    '🖖   ',
    '🙅   ',
    '🙅  ',
    '🙅  ',
    '🙅   ',
    '🙅   ',
    '🙆   ',
    '🙆  ',
    '🙆  ',
    '🙆   ',
    '🙆   ',
    '🙇   ',
    '🙇  ',
    '🙇  ',
    '🙇   ',
    '🙇   ',
    '🙋   ',
    '🙋  ',
    '🙋  ',
    '🙋   ',
    '🙋   ',
    '🙌   ',
    '🙌  ',
    '🙌  ',
    '🙌   ',
    '🙌   ',
    '🙍   ',
    '🙍  ',
    '🙍  ',
    '🙍   ',
    '🙍   ',
    '🙎   ',
    '🙎  ',
    '🙎  ',
    '🙎   ',
    '🙎   ',
    '🙏   ',
    '🙏  ',
    '🙏  ',
    '🙏   ',
    '🙏   ',
    '🚣   ',
    '🚣  ',
    '🚣  ',
    '🚣   ',
    '🚣   ',
    '🚴   ',
    '🚴  ',
    '🚴  ',
    '🚴   ',
    '🚴   ',
    '🚵   ',
    '🚵  ',
    '🚵  ',
    '🚵   ',
    '🚵   ',
    '🚶   ',
    '🚶  ',
    '🚶  ',
    '🚶   ',
    '🚶   ',
    '🛀   ',
    '🛀  ',
    '🛀  ',
    '🛀   ',
    '🛀   ',
    '🛌   ',
    '🛌  ',
    '🛌  ',
    '🛌   ',
    '🛌   ',
    '🤌   ',
    '🤌  ',
    '🤌  ',
    '🤌   ',
    '🤌   ',
    '🤏   ',
    '🤏  ',
    '🤏  ',
    '🤏   ',
    '🤏   ',
    '🤘   ',
    '🤘  ',
    '🤘  ',
    '🤘   ',
    '🤘   ',
    '🤙   ',
    '🤙  ',
    '🤙  ',
    '🤙   ',
    '🤙   ',
    '🤚   ',
    '🤚  ',
    '🤚  ',
    '🤚   ',
    '🤚   ',
    '🤛   ',
    '🤛  ',
    '🤛  ',
    '🤛   ',
    '🤛   ',
    '🤜   ',
    '🤜  ',
    '🤜  ',
    '🤜   ',
    '🤜   ',
    '🤞   ',
    '🤞  ',
    '🤞  ',
    '🤞   ',
    '🤞   ',
    '🤟   ',
    '🤟  ',
    '🤟  ',
    '🤟   ',
    '🤟   ',
    '🤦   ',
    '🤦  ',
    '🤦  ',
    '🤦   ',
    '🤦   ',
    '🤰   ',
    '🤰  ',
    '🤰  ',
    '🤰   ',
    '🤰   ',
    '🤱   ',
    '🤱  ',
    '🤱  ',
    '🤱   ',
    '🤱   ',
    '🤲   ',
    '🤲  ',
    '🤲  ',
    '🤲   ',
    '🤲   ',
    '🤳   ',
    '🤳  ',
    '🤳  ',
    '🤳   ',
    '🤳   ',
    '🤴   ',
    '🤴  ',
    '🤴  ',
    '🤴   ',
    '🤴   ',
    '🤵   ',
    '🤵  ',
    '🤵  ',
    '🤵   ',
    '🤵   ',
    '🤶   ',
    '🤶  ',
    '🤶  ',
    '🤶   ',
    '🤶   ',
    '🤷   ',
    '🤷  ',
    '🤷  ',
    '🤷   ',
    '🤷   ',
    '🤸   ',
    '🤸  ',
    '🤸  ',
    '🤸   ',
    '🤸   ',
    '🤹   ',
    '🤹  ',
    '🤹  ',
    '🤹   ',
    '🤹   ',
    '🤽   ',
    '🤽  ',
    '🤽  ',
    '🤽   ',
    '🤽   ',
    '🤾   ',
    '🤾  ',
    '🤾  ',
    '🤾   ',
    '🤾   ',
    '🥷   ',
    '🥷  ',
    '🥷  ',
    '🥷   ',
    '🥷   ',
    '🦵   ',
    '🦵  ',
    '🦵  ',
    '🦵   ',
    '🦵   ',
    '🦶   ',
    '🦶  ',
    '🦶  ',
    '🦶   ',
    '🦶   ',
    '🦸   ',
    '🦸  ',
    '🦸  ',
    '🦸   ',
    '🦸   ',
    '🦹   ',
    '🦹  ',
    '🦹  ',
    '🦹   ',
    '🦹   ',
    '🦻   ',
    '🦻  ',
    '🦻  ',
    '🦻   ',
    '🦻   ',
    '🧍   ',
    '🧍  ',
    '🧍  ',
    '🧍   ',
    '🧍   ',
    '🧎   ',
    '🧎  ',
    '🧎  ',
    '🧎   ',
    '🧎   ',
    '🧏   ',
    '🧏  ',
    '🧏  ',
    '🧏   ',
    '🧏   ',
    '🧑   ',
    '🧑  ',
    '🧑  ',
    '🧑   ',
    '🧑   ',
    '🧒   ',
    '🧒  ',
    '🧒  ',
    '🧒   ',
    '🧒   ',
    '🧓   ',
    '🧓  ',
    '🧓  ',
    '🧓   ',
    '🧓   ',
    '🧔   ',
    '🧔  ',
    '🧔  ',
    '🧔   ',
    '🧔   ',
    '🧕   ',
    '🧕  ',
    '🧕  ',
    '🧕   ',
    '🧕   ',
    '🧖   ',
    '🧖  ',
    '🧖  ',
    '🧖   ',
    '🧖   ',
    '🧗   ',
    '🧗  ',
    '🧗  ',
    '🧗   ',
    '🧗   ',
    '🧘   ',
    '🧘  ',
    '🧘  ',
    '🧘   ',
    '🧘   ',
    '🧙   ',
    '🧙  ',
    '🧙  ',
    '🧙   ',
    '🧙   ',
    '🧚   ',
    '🧚  ',
    '🧚  ',
    '🧚   ',
    '🧚   ',
    '🧛   ',
    '🧛  ',
    '🧛  ',
    '🧛   ',
    '🧛   ',
    '🧜   ',
    '🧜  ',
    '🧜  ',
    '🧜   ',
    '🧜   ',
    '🧝   ',
    '🧝  ',
    '🧝  ',
    '🧝   ',
    '🧝   ',
    '👨',
];
